import { render } from "./NewsroomPage.vue?vue&type=template&id=41e7b0ca"
import script from "./NewsroomPage.vue?vue&type=script&lang=js"
export * from "./NewsroomPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__